import MojitoModules from 'mojito/modules';

import {isLightColor, resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';

import {AbstractVisualFeature} from '../../../visual-feature.js';
import {ClassicCards} from '../classic-cards.js';

import {matchCardsFactory} from './factory/match-cards.factory.js';
import {selectionCardsFactory} from './factory/selection-cards.factory.js';
import {outrightCardsFactory} from './factory/outright-cards.factory.js';
import {fallbackCardsFactory} from './factory/fallback-cards.factory.js';
import {raceCardsFactory} from './factory/race-cards.factory.js';

import EVENT_CARD_DETAILS from './event-card-details.palette-schema.yaml';
import PALETTE_SCHEMA from './event-cards.palette-schema.yaml';

registerTileSchema(EVENT_CARD_DETAILS);

const {COLOR_MODES} = MojitoModules.EventCards.types;

class EventCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'EventCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const COLOR_MODE = isLightColor(PALETTE.PARENT.CARD_CONTAINER_BG, true) ? COLOR_MODES.LIGHT : COLOR_MODES.DARK;

        return {
            EventCardSkeleton: {
                container: {
                    style: {
                        height: '182px',
                        ...resolveBackground(PALETTE.PARENT.CARD_CONTAINER_BG),
                        ...generateBorder(PALETTE.PARENT.CARD_BORDER),
                    },
                },
            },
            ...matchCardsFactory(PALETTE, COLOR_MODE),
            ...selectionCardsFactory(PALETTE, COLOR_MODE),
            ...outrightCardsFactory(PALETTE, COLOR_MODE),
            ...fallbackCardsFactory(PALETTE),
            ...raceCardsFactory(PALETTE, COLOR_MODE),
        };
    }
}

new EventCardsFeature(ClassicCards);
